const breadcrumbs = document.querySelector('.page-header__breadcrumbs');
const headerContent = document.querySelector('.page-header__content');
const gallery = document.querySelector('.page-header__gallery');
const mainContainer = document.querySelectorAll('.main-container');

document.addEventListener('DOMContentLoaded', function() {
	if (breadcrumbs !== null) {
		breadcrumbs.classList.add('show');
	}

	if (headerContent !== null) {
		headerContent.classList.add('show');
	}

	if (gallery !== null) {
		gallery.classList.add('show');
	}

	if (mainContainer !== null) {
		for (var i = 0; i < mainContainer.length; i++) {
	    	mainContainer[i].classList.add('show');
	  	}
	}
});
